var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class:
        (_vm.drop.align ? _vm.drop.align : "dropdown") + " " + _vm.drop_class,
    },
    [
      _c("button", {
        class: "btn " + _vm.btn.class,
        attrs: {
          type: "button",
          id: _vm.id_dropdown,
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false",
          title: _vm.title,
        },
        domProps: { innerHTML: _vm._s(_vm.btn.titulo) },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          class: "dropdown-menu " + _vm.drop.class,
          attrs: { "aria-labelledby": _vm.id_dropdown },
        },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }